<template>
<div class="px-4 sm:px-6 lg:px-8 bg-gray-800  pt-10">
    <div class="sm:flex sm:items-center">
        <div class="sm:flex-auto text-left">
          <h1 v-if="wspierajacy" class="text-xl font-semibold text-white">Wspierajacy ({{ wspierajacy.length }})</h1>
          <p class="mt-2 text-sm text-gray-400">A list of all the pages with short data.</p>
        </div>

        <!-- <div class="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
          <button @click.prevent="showDuplicated()" class="ml-3 mr-2 inline-flex justify-center rounded-md border border-transparent bg-indigo-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2">duplicated</button>
          <button @click.prevent="open('NewTag')" type="button" class="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-700 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:w-auto">new tag</button>
        </div> -->
    </div>




    <div class=" mx-auto bg-gray-700 text-white p-6 rounded-lg shadow-md mt-5">
    <h2 class="text-2xl font-bold mb-6">Dodaj nowego wspierajacego</h2>
    <form @submit.prevent="submitForm" class="space-y-4">
      <div class="flex flex-wrap gap-4">
        <!-- Pole daty -->
        <div class="flex-2 min-w-0">
          <label for="date" class="block text-sm font-medium text-white">Data</label>
          <input
            type="date"
            id="date"
            v-model="newWspierajacy.createdAt"
            class="mt-1 block w-full px-3 py-2 border text-black border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            required
          />
        </div>
        <!-- Pole nickname -->
        <div class="flex-1 min-w-0">
          <label for="nickname" class="block text-sm font-medium text-white">Nickname</label>
          <input
            type="text"
            id="nickname"
            v-model="newWspierajacy.nickname"
            placeholder="Wpisz swój nickname"
            class="mt-1 block w-full px-3 py-2 border text-black border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            required
          />
        </div>
        <!-- Pole wiadomości -->
        <div class="flex-1 min-w-0">
          <label for="message" class="block text-sm font-medium text-white">Wiadomość</label>
          <input
            type="text"
            id="message"
            v-model="newWspierajacy.msg"
            placeholder="Wpisz swoją wiadomość"
            class="mt-1 block w-full px-3 py-2 border text-black border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            required
          />
        </div>
        <div class="flex-2 min-w-0">
          <label for="money" class="block text-sm font-medium text-white">money</label>
          <select id="money" name="money" autocomplete="money" class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700" v-model="newWspierajacy.money">                     
            <option v-for="money in moneySet" :key="money" :value="money">{{ money }}</option>               
          </select>
        </div>
      </div>
      <!-- Przycisk -->
      <div class="flex justify-end">
        <button
          @click="addNewWspierajacy(newWspierajacy)"
          type="submit"
          class="px-4 py-2 bg-blue-500 text-white font-semibold rounded-md shadow-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
        >
          Dodaj
        </button>
      </div>
    </form>
  </div>




    <div class="mt-8 flex flex-col">
      <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
          <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
            <table class="min-w-full divide-y divide-gray-700">
              <thead class="bg-gray-700 ">
                <tr>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-200">
                    <a href="#" class="group inline-flex">
                      createdAt
                      <span class="invisible ml-2 flex-none rounded text-gray-400 group-hover:visible group-focus:visible">
                        <ChevronUpIcon class="h-5 w-5" v-if="!sortState.createdAt.ascending" aria-hidden="true" @click="sortBy('createdAt')" />
                        <ChevronDownIcon class="h-5 w-5" v-if="sortState.createdAt.ascending" aria-hidden="true" @click="sortBy('createdAt')" />                      </span>
                    </a>
                  </th>
                  <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-200 sm:pl-6">
                    <a href="#" class="group inline-flex">
                      nickname
                      <span class="invisible ml-2 flex-none rounded text-gray-400 group-hover:visible group-focus:visible">
                        <ChevronUpIcon class="h-5 w-5" v-if="!sortState.nickname.ascending" aria-hidden="true" @click="sortBy('nickname')" />
                        <ChevronDownIcon class="h-5 w-5" v-if="sortState.nickname.ascending" aria-hidden="true" @click="sortBy('nickname')" />                        </span>
                    </a>
                  </th>
                  <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-200 sm:pl-6">
                    <a href="#" class="group inline-flex">
                      msg
                      <span class="invisible ml-2 flex-none rounded text-gray-400 group-hover:visible group-focus:visible">
                        <ChevronUpIcon class="h-5 w-5" v-if="!sortState.msg.ascending" aria-hidden="true" @click="sortBy('msg')" />
                        <ChevronDownIcon class="h-5 w-5" v-if="sortState.msg.ascending" aria-hidden="true" @click="sortBy('msg')" />                        </span>
                    </a>
                  </th>
 
                 
                  <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
                    <span class="sr-only">Edit</span>
                  </th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-700 bg-gray-800">
    <tr v-for="item in wspierajacy" :key="item.id">
      <td class="whitespace-nowrap px-3 py-4 text-left text-sm text-gray-400">{{ formatFirebaseTimestamp(item.createdAt) }}</td>
      <td class="whitespace-nowrap py-4 pl-4 pr-3 text-left text-sm font-medium text-white sm:pl-6">{{ item.nickname }}</td>
      <td class="whitespace-nowrap py-4 pl-4 pr-3 text-left text-sm font-medium text-white sm:pl-6">{{ item.msg }}</td>
      <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
        <router-link :to="{ name: 'tag', params: { id: item.id }}" class="text-indigo-500 hover:text-indigo-700">
          Edit<span class="sr-only">, {{ item.tag }}</span>
        </router-link>
      </td>
    </tr>
</tbody>

            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>






<script setup>

import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/vue/20/solid'
import { ref, onMounted, reactive, computed } from 'vue';
import { convertDateFormat } from '@/composables/convertDateFormat';
import { useRoute, useRouter } from 'vue-router'

import { Timestamp } from 'firebase/firestore';

import getCollection from '@/composables/getCollection';
import addDocumentWithId from '../composables/addDocumentWithId.js';
import { apiFetch } from '../composables/apiClient';


const { documents: wspierajacy } = getCollection('wspierajacy'); //


    const router = useRouter()
    const route = useRoute();

    const dane = ref([]);
    const groups = ref([]);

    const sortState = reactive({
      id: { ascending: true },
      nickname: { ascending: true },
      createdAt: { ascending: true },
      msg: { ascending: true },
  
    });

    const moneySet = ref([5, 11, 13, 27, 33, 55, 'other'])

    const newWspierajacy = ref({
    
    })

function formatFirebaseTimestamp(firebaseTimestamp) {
    if (!firebaseTimestamp || typeof firebaseTimestamp !== 'object') {
      throw new Error("Invalid Firebase timestamp");
    }

    const seconds = firebaseTimestamp.seconds;
    const nanoseconds = firebaseTimestamp.nanoseconds;

    // Convert to milliseconds
    const milliseconds = seconds * 1000 + Math.floor(nanoseconds / 1e6);

    // Create a new Date object
    const date = new Date(milliseconds);

    // Extract day, month, and year
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1; // Months are 0-based, so add 1
    const year = date.getUTCFullYear();

    // Format day and month to always be two digits
    const formattedDay = day.toString().padStart(2, '0');
    const formattedMonth = month.toString().padStart(2, '0');

    // Return the formatted date
    return `${formattedDay}-${formattedMonth}-${year}`;
}

function formatDateToYYYYMMDD(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Miesiące są indeksowane od 0, więc dodajemy 1
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}



function convertToFirebaseTimestamp(dateString) {
  // Utworzenie obiektu Date z formatu YYYY-MM-DD
  const date = new Date(dateString + 'T00:00:00Z'); // Dodanie czasu zapewnia, że jest to czas UTC
  
  // Konwersja na Timestamp Firebase
  const timestamp = Timestamp.fromDate(date);

  return timestamp;
}



const addNewWspierajacy = async (item) => {
  console.log('addNewWspierajacy')

    const documentId = `${item.createdAt.toString()}-${item.nickname.replaceAll(" ", "_")}-${item.money}`;

    const timestamp = convertToFirebaseTimestamp(item.createdAt);
    
    
    console.log("timestamp:", timestamp)
    console.log("Document ID:", documentId);
    
    
    const preparedData = {
      ...item,
    };

    preparedData.createdAt = timestamp;
    
    console.log("Prepared data:", preparedData);


    await addDocumentWithId('wspierajacy', documentId, preparedData);


    newWspierajacy.value = {  
      id: null,
      nickname: null,
      createdAt: null,
      msg: null,
      money: null}

}



function parseStringToArray(string) {
  try {
    return JSON.parse(string);
  } catch (e) {
    console.error("Parsing error:", e);
    return []; // Zwraca pustą tablicę w przypadku błędu
  }
}

    const sortBy = (key) => {
  // Przełączanie kierunku sortowania dla danej kolumny
  sortState[key].ascending = !sortState[key].ascending;

  // Wykonanie sortowania
  dane.value.sort((a, b) => {
    if (a[key] < b[key]) {
      return sortState[key].ascending ? -1 : 1;
    }
    if (a[key] > b[key]) {
      return sortState[key].ascending ? 1 : -1;
    }
    return 0;
  });
};

    onMounted(async () => {
      try {
        const response = await apiFetch('/api/dane');
        if (response.ok) {
          const data = await response.json();
          dane.value = data.data;
          sortBy("publishedat")
          // groups.value = Array.from(new Set(data.data.map(item => item.tagGroup))).sort();

        } else {
          throw new Error('Problem z pobraniem danych');
        }
      } catch (error) {
        console.error(error);
      }
    });



    const checkDuplicatedContent = (array) => {
    const metaDescriptionMap = {};
    const descriptionMap = {};

    // Mapowanie obiektów według ich wartości metaDescription i description
    array.forEach(obj => {
        if (obj.metaDescription) {
            if (!metaDescriptionMap[obj.metaDescription]) {
                metaDescriptionMap[obj.metaDescription] = [];
            }
            metaDescriptionMap[obj.metaDescription].push(obj);
        }
        if (obj.description) {
            if (!descriptionMap[obj.description]) {
                descriptionMap[obj.description] = [];
            }
            descriptionMap[obj.description].push(obj);
        }
    });

    // Filtrowanie obiektów, które mają powtarzające się wartości metaDescription lub description
    const filteredArray = array.filter(obj => 
        (obj.metaDescription && metaDescriptionMap[obj.metaDescription].length > 1) ||
        (obj.description && descriptionMap[obj.description].length > 1)
    );

    // Sortowanie według metaDescription lub description
    return filteredArray.sort((a, b) => {
        const aValue = a.metaDescription || a.description;
        const bValue = b.metaDescription || b.description;
        if (aValue < bValue) return -1;
        if (aValue > bValue) return 1;
        return 0;
    });
}



const showDuplicated = () => {
  dane.value = checkDuplicatedContent(dane.value)
}


const landingPageCount = computed(() => {
  if (dane.value.length > 0) {
    return dane.value.filter(item => item.haslandingpage).length;
  } else {
    return 0;
  }
});

const open = (name) => {
  console.log(name)
  router.push({ name })
}




</script>
